module.exports = __webpack_public_path__ + "assets/img/logo.1dbe42a1.png";